import { Modal } from "@/common/components/modal"
import Form from "@/common/components/form/Form"
import { getFormInputs } from "./data"

interface Props {
  isOpen: boolean
  onClose: () => void
  submitLoading: boolean
  onSubmit: (formValues: any) => void
}

export default function AddClusterModal({ isOpen, onClose, submitLoading, onSubmit }: Props) {
  return (
    <Modal title="New Cluster" isOpen={isOpen} close={onClose}>
      <div className="modal max-w-[600px] md:w-[600px] min-h-[300px] bg-white">
        <Form formInputs={getFormInputs()} processInputs={onSubmit} loadingState={submitLoading} />
      </div>
    </Modal>
  )
}
